import axios from 'axios'
import { Message } from 'element-ui'

/** 官网 axios 实例，baseURL 取自 VUE_APP_BASE_API */
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        Message.error(res.msg || '登录已过期')
      }
      return res
    }
    return res
  },
  error => {
    let message = '请求失败'
    if (error.response) {
      const raw = error.response.data
      const data = typeof raw === 'string' ? (() => {
        try { return JSON.parse(raw) } catch (e) { return null }
      })() : raw
      if (data && (data.msg || data.message)) {
        message = data.msg || data.message
      }
      switch (error.response.status) {
        case 400:
          message = (data && (data.msg || data.message)) || message || '请求参数错误'
          break
        case 401:
          message = (data && (data.msg || data.message)) || '认证失败'
          break
        case 500:
          if (data && (data.msg || data.message)) {
            message = data.msg || data.message
          }
          break
      }
    } else if (error.message) {
      message = error.message
    }
    return { code: error.response && error.response.status === 400 ? 400 : 500, msg: message }
  }
)

export default service
